class PostWrapper {
	container
	postsPerGroup = 6
	groups = []

	get lastGroup () {
		return this.groups[this.groups.length - 1]
	}

	getLastNotFullGroup () {
		let group = this.lastGroup

		if (!group || group.children.length >= this.postsPerGroup) group = this.createGroup()

		return group
	}

	createGroup () {
		const group = document.createElement('div')
		group.classList.add('grid-wrapper')
		this.groups.push(group)

		this.container.appendChild(group)

		return group
	}

	setContainer (container) {
		this.container = container
		return this
	}

	setPostsPerGroup (postsPerGroup) {
		this.postsPerGroup = postsPerGroup
		return this
	}

	render (post) {
		if (this.postsPerGroup === false) return this.renderAll(post)
		this.renderInGroup(post)
	}

	renderAll (post) {
		post.render()
		this.container.appendChild(post.element)
	}

	renderInGroup (post) {
		const group = this.getLastNotFullGroup()
		post.render()
		group.appendChild(post.element)
		this.renderGroupsLength()
	}

	renderGroupsLength () {
		this.groups.map(this.renderGroupLength.bind(this))
	}

	renderGroupLength (group) {
		const length = group.children.length

		Array(this.postsPerGroup)
			.fill(0)
			.map((_, key) => group.classList.remove(`grid-wrapper-${key + 1}-child`))

		group.classList.add(`grid-wrapper-${length}-child`)
	}
}

const postWrapper = new PostWrapper()
export { PostWrapper, postWrapper }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/wrapper/PostWrapper.js